<template>
  <div class="theLoginPage">
    <v-overlay v-model="overlay"></v-overlay>
    <v-row style="margin: 0;">
      <v-col :cols="columnWidth" class="imageLogin" v-if="this.$mq !== 'sm'"
        ><img
          class="image container"
          :src="this.getImgUrl1(this.$config.background_image)"
          alt="bg image"
          style=" padding:0"
        />
        <div class="appTitle">
          <v-row v-if="this.$config.div_for_exxon_logo_on_bg_text">
            <v-col>
              <v-row>
                <img
                  :src="
                    this.getImgUrl1(this.$config.div_for_exxon_logo_on_bg_logo)
                  "
                  width="200"
                  alt="MobilServ Logo"
                />
              </v-row>
              <v-row class="appTitleActual"> IIoT Insights </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col>
        <form @submit="login()" class="loginForm" style="display: flex;">
          <div style="display: flex; flex-direction: column; ">
            <div style="padding-bottom:3vh;">
              <img
                :src="this.getImgUrl1(this.$config.image_above_input_field)"
                width="200"
                alt="Mobil Serv logo"
              />
            </div>

            <v-text-field
              style="width: 250px;"
              v-model="userName"
              required
              dense
              outlined
              autocomplete="username"
              label="Username"
              :disabled="AcceptedCookiesData"
            ></v-text-field>

            <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              style="width: 250px"
              autocomplete="current-password"
              v-model="password"
              required
              dense
              outlined
              label="Password"
              :disabled="AcceptedCookiesData"
            >
            </v-text-field>

            <p>
              <button
                :disabled="this.termsChecked"
                :class="termsChecked ? 'disablebutton' : 'loginbutton'"
                type="submit"
                @click.stop.prevent="login()"
                color="primary"
              >
                <v-progress-circular
                  v-if="disableLoginButton"
                  indeterminate
                  color="white"
                  size="18"
                  width="2"
                ></v-progress-circular>
                {{ disableLoginButton ? "Loading..." : "Login" }}
              </button>
            </p>
            <small>
              <router-link
                to="/forgotPassword"
                :style="{ 'pointer-events': AcceptedCookiesData ? 'none' : '' }"
                class="link"
                ><span
                  class="link"
                  :style="{
                    'pointer-events': AcceptedCookiesData ? 'none' : '',
                  }"
                  >Forgot Password?</span
                ></router-link
              >
            </small>

            <small v-if="this.invalidPassword && !this.blockTimeCheck">
              <span style="color:red; display:inline;">
                {{ this.errorMessage }}</span
              >
            </small>
            <!-- blocking time will shown to user -->
            <small v-if="this.blockTimeCheck">
              <span style="color:red; display:inline;">{{
                this.errorMessage[0]
              }}</span
              ><br />
              <span style="color:red; display:inline;">{{
                this.errorMessage[1]
              }}</span>

              <span style="color: red; display: inline;">
                <span>
                  {{ new Date(unixTsData * 1000).getHours() + " Hrs : " }}
                </span>
                <span>
                  {{
                    String(new Date(unixTsData * 1000).getMinutes()).padStart(
                      2,
                      "0"
                    ) + " Mins : "
                  }}
                </span>
                <span>
                  {{
                    String(new Date(unixTsData * 1000).getSeconds()).padStart(
                      2,
                      "0"
                    ) + " Secs"
                  }}
                </span>
              </span>
            </small>

            <br v-if="!this.invalidPassword" />
            <small style=" width:250px">
              <label>
                <input
                  type="checkbox"
                  :disabled="AcceptedCookiesData"
                  @click="OnCheckFuncCallBack"
                  v-model="acceptTerms"
                  style=" height:15px; width:20px"
                />
                * I have read and understood the
                <router-link target="_blank" to="/termsAndConditions">
                  Terms & Conditions</router-link
                >.
              </label>
            </small>
          </div>
        </form>
        <div
          class="generalTermsAndConditions"
          v-if="this.$config.general_terms"
        >
          <a
            style="text-decoration:none; color:#2e2d2d"
            target="_blank"
            href="https://corporate.exxonmobil.com/Global-legal-pages/terms-and-conditions"
            ><span>General Terms & Conditions</span></a
          >
          <br />
          <a
            style="text-decoration:none; color:#2e2d2d"
            target="_blank"
            href="https://corporate.exxonmobil.com/Global-legal-pages/privacy-policy"
            ><span>Privacy Policy</span></a
          >
        </div>
      </v-col>
    </v-row>
    <cookiesPolicy
      v-if="AcceptedCookiesData"
      style="position: fixed; z-index: 999; bottom: 0;"
      @hideCookies="hideCookies"
    />
  </div>
</template>
<script>
import cookiesPolicy from "../components/cookiesPolicy.vue";

const axios = require("axios").default;
let organizationMapping = {};

export default {
  components: {
    cookiesPolicy,
  },
  data: () => ({
    blockTimeCheck: false,
    unixTsData: null,
    overlay: true,
    userName: "",
    password: "",
    select: "",
    showPassword: false,
    invalidPassword: false,
    disableLoginButton: false,
    acceptTerms: false,
    termsChecked: true,
    AcceptedCookiesData: true,
    intervalId: null,
  }),

  computed: {
    columnWidth() {
      return this.$mq === "md" ? "7" : "9";
    },
  },

  methods: {
    // Fill the details of method by learning from Sumit
    blockedTimeCountDown() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.unixTsData = this.unixTsData - 1;
      }, 1000);
    },

    hideCookies(acceptedCookiesData) {
      this.AcceptedCookiesData = acceptedCookiesData;
      this.overlay = acceptedCookiesData;
    },
    reset() {
      this.userName = "";
      this.password = "";
      this.select = "";
    },
    OnCheckFuncCallBack() {
      if (this.acceptTerms == false) {
        this.termsChecked = false;
      } else {
        this.termsChecked = true;
      }
    },
    login: async function() {
      // onClick disabling the login button reassigning values to the instance vars
      this.disableLoginButton = true;
      this.success = false;
      this.error = null;
      this.blockTimeCheck = false;

      // console.log(this.userName, this.password);
      if (!this.password || !this.userName) {
        alert(
          "Double-check the login credentials: Make sure you entered the correct username and password. "
        );
      } else {
        sessionStorage.setItem("activeUser", this.userName);
        const passwordHash = Buffer.from(
          `${this.userName}:${this.password}`,
          "utf8"
        ).toString("base64");

        console.log("checking buffer", passwordHash);

        try {
          const config = {
            method: "post",
            url: `${this.$config.backend_url}/login`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Basic ${passwordHash}`,
            },
          };
          const res = await axios(config);
          this.invalidPassword = false;
          this.disableLoginButton = false;
          console.log("checking response of from backend", res);
          console.log(res.data);
          console.log(res.data.status);
          if (res.data && res.data.access_token && res.data.status === "S") {
            this.disableLoginButton = true;

            console.log("cheking login.vue", this.$router.currentRoute.path);
            sessionStorage.setItem("jwt", this.userName);
            sessionStorage.setItem("userName", res.data.user_name);
            sessionStorage.setItem("logintime", res.data.login_time);
            sessionStorage.setItem("organizationName", this.select);
            sessionStorage.setItem("token", res.data.access_token);
            sessionStorage.setItem("refreshToken", res.data.refresh_token);
            sessionStorage.setItem(
              "organizationId",
              organizationMapping[this.select]
            );
            this.$router.push("/");
            this.clearcrumbsdict();
          } else {
            this.disableLoginButton = false;
            this.invalidPassword = true;
            this.errorMessage = "Invalid Credentials, Please Try Again.";
          }
        } catch (err) {
          this.disableLoginButton = false;
          this.invalidPassword = true;
          this.error = err.message;
          if (
            err.response &&
            err.response.status === 401 &&
            err.response.data.includes("Invalid credentials, remaining")
          ) {
            this.errorMessage = err.response.data;
          } else if (
            err.response &&
            err.response.status === 401 &&
            err.response.data.includes("Your account is blocked")
          ) {
            this.blockTimeCheck = true;
            console.log("Your account is blocked");
            this.errorMessage = err.response.data.split("|");
            let timeString = err.response.data.split("|")[2]; // the sample format looks like: "19:49:10"

            const today = new Date();
            // Extracting year, month, day, hours, minutes, seconds  current date and incoming timestring
            const [year, month, day, hours, minutes, seconds] = [
              today.getFullYear(),
              today.getMonth(),
              today.getDate(),
              timeString.split(":").map(Number), // map object converts splits timestring to 3 values
            ];
            // Forming a dateTime from above extracted values
            const dateTime = new Date(
              year,
              month,
              day,
              hours,
              minutes,
              seconds
            );

            console.log("dateTimedateTime", dateTime);

            // Converting the Unix timestamp by dividing the time in terms of seconds
            const unixTimestamp = Math.floor(dateTime.getTime() / 1000);
            this.unixTsData = unixTimestamp;
            this.blockedTimeCountDown();
          } else if (
            err.response &&
            err.response.status === 401 &&
            err.response.data.includes("Your account is deactivated")
          ) {
            console.log("Your account is deactivated");
            this.errorMessage = "Your account is deactivated by admin";
          } else {
            console.log('Its an unidentified error with in if case handling=>',err.response);
            this.errorMessage = "Invalid Credentials, Please Try Again.";
          }
        }
      }
    },
  },
  beforeMount() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
    } else {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
  },
};
</script>
<style>
.span1 {
  color: #0000cd;
}
.span2,
.org,
.username,
.pwd {
  color: red;
}
.create {
  width: 15pm;
}

.label {
  color: red;
  font-weight: bold;
  font-size: 17px;
}

.tdLabel {
  text-align: right;
  padding-right: 50px;
}

.tdContent {
  align-content: center;
}

.tdbutton {
  text-align: center;
  padding: 5px;
}
.imageLogin {
  margin: 0px;
  padding: 0px;
  height: 100vh;
  overflow: hidden;
  position: relative;
  text-align: center;
  color: white;
}
.image {
  height: 100vh;
  width: 100%;
  /* padding-top: 30px;  */
}
.toBeFilled {
  padding-left: 10% !important;
  padding-right: 10% !important;
  margin: auto;
  width: 50%;
}
.appTitle {
  position: absolute;
  bottom: 8px;
  left: 60px;
}
.appTitleActual {
  font-size: 370%;
}
.logoClass {
  padding-top: 40%;
}
.eachForm {
  padding-top: 5%;
}
#loginButton {
  color: #ffffff;
}

.loginForm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 26vh;
}
.theLoginForm {
  overflow: hidden;
}
.theLoginPage {
  overflow: hidden;
  background-color: white;
  display: flex;
  height: 100%;
}
.disablebutton {
  background-color: #a3c3f3 !important;
  width: 100%;
  /* padding: 1px 90px 1px 90px; */
  font-size: 25px;
  font-weight: 600;
  border-radius: 6px;
  pointer-events: none;
  color: white;
}
.loginbutton {
  background-color: #0c479d;
  /* padding: 1px 90px 1px 90px; */
  width: 100%;
  font-size: 25px;
  font-weight: 600;
  border-radius: 6px;

  color: white;
}

.loginbutton:hover {
  background-color: #3779dd;
}

.loginInput {
  border: 1px solid black;
  padding: 10px 40px 10px 40px;
  border-radius: 5px;
}
.generalTermsAndConditions {
  position: absolute;
  bottom: 0;
  right: 0;
  padding-right: 10px;
  height: 50px;
  text-align: right;
  font-size: small;
}
.link {
  color: black;
  text-decoration: none;
}

.CookiesDisplay {
  position: absolute;
  z-index: 999;
  margin-top: 10%;
}
.CookiesDisplayHidden {
  display: none;
}
</style>
